import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetTagsLoading, EGetTagsActionType } from './types';

export const getTagsLoading: () => TGetTagsLoading = actionGenerator<EGetTagsActionType.Loading>(
  EGetTagsActionType.Loading,
);
